import { keyframes } from 'emotion';

import styled from 'utils/emotion';
import { toPx } from 'utils/styles';
import media from 'utils/mediaqueries';

import Icon from 'components/common/Icon';
import { colors } from 'components/common/Layout/variables';
import Text from '../Text';

const bounce = keyframes`
  0%, 100% {
    transform: translate3d(0,0,0);
  }

  60% {
    transform: translate3d(0, 15px, 0);
  }
`;

export const ScrollIndicatorStyled = styled('button')({}, (props) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontWeight: '700',
  letterSpacing: '0.05em',
  textDecoration: 'none',
  fontSize: '18px',
  textTransform: 'none',
  width: '100%',
  border: 0,
  backgroundColor: 'transparent',
  color: props.theme.colorTertiary,
  cursor: 'pointer',
  transition: 'color .15s',

  '& svg': {
    transition: 'transform 0.2s ease-in-out',
  },

  '& svg path': {
    transition: 'fill .2s ease-in-out',
  },

  '&:hover, &:active': {
    border: 0,
    color: props.theme.white,
    WebkitTapHighlightColor: 'transparent',
    outline: 0,

    // Actually referencing the styled component didn't work...
    '& svg': {
      transform: 'translate(0, 20%)',
    },
    '& svg path': {
      fill: 'white !important',
    },
  },

  [media('tablet')]: {
    width: 'auto',
  },
}));

export const ScrollIndicatorIconStyled = styled(Icon)(
  {
    flex: 'none',
    height: 35,
  },
  (props) => ({
    margin: `${toPx(props.theme.spaceThirds)} auto`,
  }),
);

export const ScrollIndicatorTextStyled = styled(Text)(
  {
    // H5
    fontSize: '22px',
    lineHeight: '24px',
    fontWeight: 400,
    textTransform: 'uppercase',
    [media('desktop')]: {
      // H4
      fontSize: '34px',
      lineHeight: '38px',
    },
  },
  (props) => ({
    color: props.theme.colorTertiary,
    fontFamily: props.theme.fontSecondary,
    margin: `${props.theme.spaceHalf}px 0`,
  }),
);

export const ScrollIndicatorIconWrapStyled = styled('div')({
  display: 'block',
  textAlign: 'center',
});
